export default "assets/images/header-mask-34f4092c.svg";